import { render, staticRenderFns } from "./customShare.vue?vue&type=template&id=a7103b56&scoped=true"
import script from "./customShare.vue?vue&type=script&lang=js"
export * from "./customShare.vue?vue&type=script&lang=js"
import style0 from "./customShare.vue?vue&type=style&index=0&id=a7103b56&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7103b56",
  null
  
)

export default component.exports